import React, { useEffect, useState } from "react";
import "../styles/blogs.scss";
import Headertop from "../components/Headertop";
import BlogCard from "../components/BlogCard";
import axios from "axios";
import { TextField, MenuItem } from "@mui/material";
import { FcSearch } from "react-icons/fc";
import { Helmet } from "react-helmet";
import Loader from "../components/Loader";

const Blog = () => {
  const [data, setData] = useState([]);
  const [cat, setCat] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);

  const getDataById = async () => {
    try {
      const res = await axios.get(
        "https://tomcat.diwise.in/HCCBlogsandContact/blog/getallblogs"
      );
      const blogs = res.data.map((item) => item.data);
      setData(blogs);
      setFilteredData(blogs);

      const categories = [...new Set(blogs.map((blog) => blog.category))];
      setCat(categories);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getDataById();
  }, []);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    filterData(event.target.value, selectedCategory);
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    filterData(searchQuery, event.target.value);
  };

  const filterData = (query, category) => {
    let filteredPosts = data;

    if (query) {
      filteredPosts = filteredPosts.filter((post) =>
        post.title.toLowerCase().includes(query.toLowerCase())
      );
    }

    if (category) {
      filteredPosts = filteredPosts.filter(
        (post) => post.category === category
      );
    }

    setFilteredData(filteredPosts);
    setVisibleCount(2);
  };

  const handleClearFilters = () => {
    setSearchQuery("");
    setSelectedCategory("");
    setFilteredData(data);
    setVisibleCount(2);
  };

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 2);
  };

  console.log(filteredData, ">>>>>>");
  

  return (
    <>
      <Helmet>
        <title>
          Blog - Stay Informed with Healthcare Concierge's Latest Articles
        </title>
        <meta
          name="description"
          content="Explore our collection of blogs at Healthcare Concierge. Read informative health articles, wellness tips, medical insights, and the latest healthcare news."
        />
      </Helmet>

      <Headertop
        title="Blogs"
        desc="Explore inlogsightful perspectives and engaging content."
      />

      {/* Filter */}
      <div className="filter-parent parent">
        <div className="filter-container container">
          <div className="filter-box">
            <div className="input">
              <span className="search-icon">
                <FcSearch />
              </span>
              <input
                type="text"
                placeholder="Search Your Blogs"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
            <TextField
              select
              label="Category"
              fullWidth
              value={selectedCategory}
              onChange={handleCategoryChange}
            >
              <MenuItem value="">All Categories</MenuItem>
              {cat.map((category, index) => (
                <MenuItem key={index} value={category}>
                  {category}
                </MenuItem>
              ))}
            </TextField>
            <button
              className="btn-dark-blue reset-btn"
              onClick={handleClearFilters}
            >
              Clear
            </button>
          </div>
        </div>
      </div>

      {/* Blogs */}
      <div className="allblogsparent parent">
        <div className="allblogscontainer container">
          {filteredData.length > 0 ? (
            filteredData
              .slice(0, visibleCount)
              .map((post, index) => (
                <BlogCard
                  id={post.bid}
                  key={index}
                  date={post.date}
                  cat={post.category}
                  title={post.title}
                  content={post.description}
                  url={post?.featuredImage}
                />
              ))
          ) : (
            <Loader/>
          )}
        </div>

        {/* Load More */}
        {visibleCount < filteredData.length && (
          <div className="load-more-btn">
            <button className="btn-dark-blue" onClick={handleLoadMore}>
              Load More
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Blog;
